import React from 'react';
import { Tooltip } from '@mui/material';
import { formatCompact, formatNumber } from './chartTheme';
import '../../css/heatmap.css';

// Sequential blue ramp, light → dark (steps 100…700). Steps from 400 up are
// dark enough to need white text.
const RAMP = ['#cde2fb', '#9ec5f4', '#6da7ec', '#3987e5', '#256abf', '#184f95', '#0d366b'];
const DARK_FROM = 3;

const stepOf = (v, max) => (v <= 0 || max <= 0 ? -1 : Math.min(RAMP.length - 1, Math.floor((v / max) * RAMP.length)));

// "2026-01" → "2026.01"
const monthLabel = (m) => String(m).replace('-', '.');

/**
 * rows: [{ label, values: number[] }] aligned to `columns`.
 * Rows are shown largest total first; every cell is a hover target.
 */
export default function Heatmap({ columns, rows, unit = '' }) {
    const sorted = rows
        .map((r) => ({ ...r, total: r.values.reduce((a, b) => a + (Number(b) || 0), 0) }))
        .sort((a, b) => b.total - a.total);
    const max = Math.max(0, ...sorted.flatMap((r) => r.values.map(Number)));

    return <div className="hm">
        <div className="hmscroll">
            <table className="hmtable">
                <thead>
                    <tr>
                        <th className="hmname">Компани</th>
                        {columns.map((c) => <th key={c}>{monthLabel(c)}</th>)}
                        <th className="hmtotal">Нийт</th>
                    </tr>
                </thead>
                <tbody>
                    {sorted.map((r) => (
                        <tr key={r.label}>
                            <th className="hmname" scope="row" title={r.label}>{r.label}</th>
                            {columns.map((c, i) => {
                                const v = Number(r.values[i]) || 0;
                                const s = stepOf(v, max);
                                return <Tooltip
                                    key={c}
                                    arrow
                                    disableInteractive
                                    title={<span>{r.label}<br />{monthLabel(c)}: <b>{unit}{formatNumber(v)}</b></span>}
                                >
                                    <td
                                        className={s < 0 ? 'hmcell hmzero' : 'hmcell'}
                                        style={s < 0 ? undefined : { background: RAMP[s], color: s >= DARK_FROM ? '#ffffff' : '#1d2939' }}
                                    >
                                        {s < 0 ? '–' : formatCompact(v)}
                                    </td>
                                </Tooltip>
                            })}
                            <td className="hmtotal">{unit}{formatCompact(r.total)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        <div className="hmlegend" aria-hidden="true">
            <span>0</span>
            <div className="hmramp">
                {RAMP.map((c) => <i key={c} style={{ background: c }} />)}
            </div>
            <span>{unit}{formatCompact(max)}</span>
        </div>
    </div>
}
